import React, { useEffect, useState } from "react";
import CompanyInput from "../../Inputs/CompanyInput/CompanyInput";
import UpdateBranch from "../UpdateBranch/UpdateBranch";
import { useDispatch, useSelector } from "react-redux";
import { updateCompany } from "../../../redux/companySlice/companySlice";
import notify from "../../../hooks/useNotifaction";

export default function UpdateCompany({ company }) {
  const dispatch = useDispatch();
  const { error, status } = useSelector((state) => state.company);
  const [loading, setLoading] = useState(true);
  const [companyData, setCompanyData] = useState({
    id: "",
    name: "",
    email: "",
    logo: null,
    address: "",
    city: "",
    state: "",
    location: "",
    phone: "",
    commercial_record: "",
    tax_number: "",
    status: "",
  });

  useEffect(() => {
    if (company) {
      setCompanyData(company);
    }
  }, [company]);
  useEffect(() => {
    console.log(companyData);
  }, [companyData]);
  const onInputChange = (id, value) => {
    setCompanyData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  function handleForm(e) {
    e.preventDefault();
    setLoading(true);
    try {
      dispatch(updateCompany({ data: companyData, id: companyData.id }));
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }
  useEffect(() => {
    if (!loading) {
      console.log(status);
      if (status === "succeeded") {
        notify("تم التحديث بنجاح", "success");
      } else {
        if (error) {
          if (error.message) {
            notify(error.message, "error");
          } else {
            notify("حدث خطأ", "error");
          }
        }
      }
    }
  }, [status, error, loading]);
  return (
    <>
      <form onSubmit={handleForm}>
        <div className="card mb-3 pt-5 pb-2 px-3">
          <CompanyInput onInputChange={onInputChange} companyData={companyData} company={company} />
          <div>
            <button className="btn btn-primary">
              <i className="fa fa-save me-1"></i>
              حفظ
            </button>
          </div>
        </div>
      </form>
    </>
  );
}
